// src/components/molecules/SubmissionDetails/CommentsList.js

import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CommentItem from "../../atoms/SubmissionDetails/CommentItem";

const CommentsList = ({ comments, loadingComments, theme }) => {
  if (loadingComments) {
    return (
      <CircularProgress
        sx={{
          color: theme.colors.red,
        }}
      />
    );
  }

  if (comments.length === 0) {
    return (
      <Typography variant="body1" sx={{ ml: 3, fontFamily: "basic-sans" }}>
        No comments yet. Be the first to comment!
      </Typography>
    );
  }

  return (
    <Box>
      {comments.map((comment) => (
        <CommentItem key={comment.id} comment={comment} />
      ))}
    </Box>
  );
};

export default CommentsList;
